import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { PageLayout } from '@src/common/PageLayout';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { useLocation } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { Button } from '@uhg-abyss/web/ui/Button';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { StepTracker } from '../StepTracker';

const PageName = styled('h1', {
  fontSize: '36px',
  fontWeight: 600,
  paddingTop: '20px',
  textAlign: 'left',
  fontFamily: '$heading',
  color: '$primary1',
});

const Heading = styled('p', {
  fontWeight: 500,
  paddingTop: '5px',
  paddingBottom: '18px',
  textAlign: 'left',
  fontFamily: '$primary',
});

const DownloadPdf = styled('div', {
  fontWeight: 500,
  paddingTop: '25%',
  paddingLeft: '15%',
  display: 'inline-flex',
});

export const TinHeader = ({ callPdf, downloading, trackingNumber }) => {
  const form = useForm();
  const location = useLocation();
  const router = useRouter();
  const billingTin = form.getValues('searchRegistration.billingTin');

  useEffect(() => {
    if (!billingTin) {
      router.navigate('/');
    }
  }, []);

  const downloadPdf = () => {
    callPdf();
  };

  return (
    <React.Fragment>
      <PageLayout>
        <Grid>
          <Grid.Col span="77%">
            <PageName>Register TIN: {billingTin}</PageName>
            <Heading>
              Please provide your practice's required TIN and data for each of
              these steps.
            </Heading>
          </Grid.Col>
          {(location.pathname.includes('/confirmation') ||
            location.pathname.includes('/step/4')) &&
            trackingNumber && (
              <Grid.Col span="23%">
                <DownloadPdf>
                  <Button
                    variant="tertiary"
                    isLoading={downloading}
                    onClick={downloadPdf}
                    id='Pdf-downloadButton'
                    before={<IconSymbol icon="print" size="20px" />}
                  >
                    Print/Save as PDF
                  </Button>
                </DownloadPdf>
              </Grid.Col>
            )}
        </Grid>
        <StepTracker />
      </PageLayout>
    </React.Fragment>
  );
};

TinHeader.propTypes = {
  callPdf: PropTypes.func,
  downloading: PropTypes.bool,
  trackingNumber: PropTypes.string,
};

TinHeader.defaultProps = {
  callPdf: () => {},
  downloading: false,
  trackingNumber: '',
};
